if($('.top-cat .subcategories').length){
    function mmshowmore(){
        $(".top-cat .subcategories").each(function(index){
          $(this).addClass('index-'+index)
          if($(this).find('li').length){
            var findfilter = $(this).find('li').length;
          }
          $(this).attr('subcat-number', findfilter)
          if(findfilter > 8){
            var lifirts = $(this).find("li:lt('8')");
            var linext = $(this).find("li").not(":lt('8')");
            $(linext).hide()
            $(lifirts).addClass('show')
            if(!$('.btn-overflow' + index).length){
                $(this).after('<div class="showbutton"><a class="btn-overflow less chevron-after chevron-down-after" style="display: block">Zobrazit další kategorie</a></div>');
                var text = $('.mhnext' + index);
                var btn = $('.btn-overflow');
                btn.click(function(e) {
                  e.stopPropagation();
                  if (btn.hasClass('less')) {
                    btn.removeClass('less chevron-after chevron-down-after');
                    btn.addClass('more chevron-after chevron-up-after');
                    btn.text('Zobrazit méně');
                    $(linext).show('500')
                  } else {
                    btn.removeClass('more chevron-after chevron-up-after');
                    btn.addClass('less chevron-after chevron-down-after');
                    btn.text('Zobrazit další kategorie');
                    $(linext).hide('500')
                  }
                });
            }
          }
    
        })
        }
        $(document).ready(function(){
          mmshowmore()
        })
        document.addEventListener('ShoptetDOMPageContentLoaded', function() {
          mmshowmore()
        });
        document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
          mmshowmore()
        });
      }